import { createDecorator } from '../../instantiation/common/instantiation.js';
const IKeybindingService = ( createDecorator('keybindingService'));
export { IKeybindingService };
